import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Avatar, Typography, theme } from 'antd';

import { StarFilled } from '@ant-design/icons';

import useAdmin from "hooks/useAdmin";

const { useToken } = theme;

const { Text } = Typography;

const PlayerInfo = ({player, showAvatar, showSellingPrice}) => {

    const { adminData } = useAdmin();
    const { token } = useToken();

    return (
        <Row align="middle" gutter={8}>
            {showAvatar &&
                <Col>
                    <Avatar src={`/images/${player.positionId}.svg`} size={32} />
                </Col>
            }
            <Col>
                <Text strong style={{ marginBottom: 0 }}>{player.name}</Text> {player.teamOfTheWeek && <StarFilled style={{marginLeft: 2, color: token.colorStar }} />}
                <br />
                
                <Text type="warning">{adminData.currency()}{showSellingPrice ? player.sellingPrice : player.adjustedValue}m</Text><Text type="secondary"> | {player.positionName}</Text>
            </Col>
        </Row>
    )
}

PlayerInfo.defaultProps = {
    showAvatar: true,
    showSellingPrice: false
}

PlayerInfo.propTypes = {
    player: PropTypes.object.isRequired,
    showAvatar: PropTypes.bool,
    showSellingPrice: PropTypes.bool
}

export default PlayerInfo;